import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { getRouteUrl } from '@utils/urls';

import CMSComponentsRenderer from '@common/components/CMSComponents/CMSComponentsRenderer';
import Layout from '@common/containers/Layout';
import RouteLayout from '@common/containers/RouteLayout';
import { REGISTER, PRE_LOGIN, PRE_REGISTER } from '@common/routes';

import {
  Content,
  LinkCard,
  LinkCardTitle,
  RegisterIcon,
  Wrapper,
} from './PreRegister.styled';

function LinksComponent() {
  const { locale } = useRouter();
  const { t } = useTranslation('common');

  return (
    <Link
      legacyBehavior
      passHref
      href={REGISTER}
      as={getRouteUrl(locale, REGISTER)}
    >
      <LinkCard>
        <RegisterIcon />
        <LinkCardTitle>
          {t('preRegisterAccountTitle', 'VIP-Konto erstellen')}
        </LinkCardTitle>
      </LinkCard>
    </Link>
  );
}

export function PreRegister({ pageData }) {
  const { locale } = useRouter();
  const { t } = useTranslation('common');
  const pageUrl = getRouteUrl(locale, PRE_REGISTER);

  return (
    <Layout
      title={t('preRegisterMetaTitle', 'Pre-Register')}
      canonicalPageUrl={pageUrl}
    >
      <RouteLayout
        backRoute={PRE_LOGIN}
        backRouteAs={getRouteUrl(locale, PRE_LOGIN)}
        title={t('preRegisterTitle', 'Werde jetzt Chicorée VIP!')}
        stickyTitle={t('preRegisterTitle', 'Werde jetzt Chicorée VIP!')}
        columns={8}
      >
        <Wrapper>
          <LinksComponent />
          <Content>
            <CMSComponentsRenderer body={pageData?.body} />
          </Content>
          <LinksComponent />
        </Wrapper>
      </RouteLayout>
    </Layout>
  );
}

PreRegister.propTypes = {
  pageData: PropTypes.shape({
    body: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default PreRegister;
